import ApproachPrincipalBuilder from 'components/OurApproach/ApproachPrincipalBuilder'
import React from 'react'
import parser from 'html-react-parser'

export default function ContentCards6({ data }) {
    const { contentCards6Text, contentCards6Title, contentCards6Cards } = data
    return (
        <div className='offer-wrap panel-space-70 principals-wrap'>
            <div className='container sm-container-1'>
                <div className='row'>
                    <div className='col-md-12 text-center mb-3'>
                        <h2 className='heading-level-2 blue-color text-center mb-3'>
                            {contentCards6Title && parser(contentCards6Title)}
                        </h2>
                        <p>
                            <strong>{contentCards6Text && parser(contentCards6Text)}</strong>
                        </p>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        {contentCards6Cards.map((block, i) => (
                            <ApproachPrincipalBuilder key={i} block={block} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
